/** @format */

import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  getAboutMeReducer,
  getApiProjectsReducer,
  getCertificateReducer,
  getMobileProjectsReducer,
  getOtherProjectsReducer,
  getSocialLink,
  getTimeStamp,
  getUiProjectsReducer,
  getWebProjectsReducer,
  postCommets,
} from "./reducer/notesReducers";

const reducer = combineReducers({
  getAboutMe: getAboutMeReducer,
  getWebProjects: getWebProjectsReducer,
  getMobileProjects: getMobileProjectsReducer,
  getApiProjects: getApiProjectsReducer,
  getUiProjects: getUiProjectsReducer,
  getOtherProjects: getOtherProjectsReducer,
  getCertificate: getCertificateReducer,
  postCommet: postCommets,
  SocialLinks: getSocialLink,
  TimeStamps: getTimeStamp,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
